import React, { useEffect, useState } from "react";
import { Toast } from 'antd-mobile'
import styled from "styled-components";
import Header from "@/components/Header";
import styles from '@/styles';
import AlipayIcon from './imgs/alipay-icon@2x.png';
import WithdrawClock from './imgs/withdraw-clock@2x.png';
import bridge from '@/config/JSbridge'
import { getWithdrawable, submitWithdraw } from './api';
import { invite_bg, invite_text, invite_card_bg } from '@/styles/theme'
import get from 'lodash/get'

const MyInvitation = () => {
  const [data, setData] = useState({});

  const [requiredWithdraw, setRequiredWithdraw] = useState(false);

  useEffect(() => {
    getData().then(res => {
      setData(res)
    })
  }, [])

  const getData = () => {
    return new Promise((resolve, reject) => {
      getWithdrawable({ activityId: 60 }).then(res => {
        resolve(res);
      })
    })
  }

  const handleSubmitWithdraw = () => {
    submitWithdraw({ activityId: 60, bonus: data.withdrawableBonus }).then(res => {
      if (res.errors) {
        Toast.info(res.errors[0].message)
        return;
      }
      setRequiredWithdraw(true);
    }).catch(err => {
      const msg = get(err, 'response.data.errors[0].message')
      if (msg) {
        Toast.info(msg);
      }
    })
  }

  const handleFinish = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'popPage',
        params: {
          index: '-1'
        }
      },
      () => {
        
      }
    );
  }

  return (
    <Container>
      <Header
        title="邀请好友活动提现"
        hideNaviBar
        bg_color={styles.bg_color2}
        className="page-header"
      />
      <div className="withdraw-wrap">
        {
          !requiredWithdraw ? (
            <div className="withdraw-card">
              <div className="withdraw-title">提现金额</div>
              <div className="withdraw-value">
                <span className="withdraw-unit">¥</span>
                <span>{data.withdrawableBonus || 0}</span>
              </div>
              <div className="withdraw-desc">目前可提金额{data.withdrawableBonus || 0}元，仅支持全部金额提现</div>
              <div className="withdraw-account">
                <div>提现至</div>
                <div className="account-desc">
                  <img className="ali-icon" src={AlipayIcon} alt=""/>
                  <span>支付宝{data.aliPayInfo ? `(${data.aliPayInfo})` : null}</span>
                </div>
              </div>
              <div onClick={handleSubmitWithdraw} className="confirm-btn">
                确认提现
              </div>
            </div>
          ): (
            <div className="withdraw-finish">
              <div className="withdraw-clock-wrap">
                <img className="withdraw-clock" alt="" src={WithdrawClock} />
              </div>
              <div className="finish-text">提现申请已提交</div>
              <div className="finish-desc">提现资金预计会在提交申请后5个工作日内到账</div>
              <div onClick={handleFinish} className="finish-btn-wrap">
                <div className="finish-btn">完成</div>
              </div>
            </div>
          )
        }
      </div>
    </Container>
  )
}

export default MyInvitation;

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  .withdraw-wrap {
    flex: 1;
    width: 100%;
    background: ${invite_bg};
    padding: 0 18px;
    box-sizing: border-box;
  }
  .page-header {
    height: 44px;
  }
  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }

  .withdraw-card {
    margin-top: 27px;
    background: ${invite_card_bg};
    box-shadow: 0px 7px 8px 0px rgba(45,45,45,0.21);
    border-radius: 10px;
    padding: 18px 20px 21px;
  }

  .confirm-btn {
    margin-top: 26px;
    height: 38px;
    border: 0px solid #FFFFFF;
    background: linear-gradient(270deg, #FB4C3D 0%, #FDBE37 99%);
    border-radius: 19px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
  }

  .withdraw-title {
    font-size: 15px;
    font-weight: 500;
    color: ${invite_text};
    line-height: 15px;
  }
  .withdraw-value {
    font-size: 40px;
    font-weight: bold;
    color: ${invite_text};
    line-height: 40px;
    margin-top: 25px;
  }
  .withdraw-unit {
    margin-right: 9px;
  }
  .withdraw-desc {
    margin-top: 18px;
    font-size: 11px;
    font-weight: 400;
    color: #9696a6;
    line-height: 11px;
  }
  .withdraw-account {
    display: flex;
    align-items: center;
    margin-top: 25px;
    justify-content: space-between;
    color: ${invite_text};
  }
  .ali-icon {
    width: 18px;
    height: 19px;
    margin-right: 5px;
  }
  .account-desc {
    display: flex;
    align-items: center;
  }
  .withdraw-clock-wrap {
    padding-top: 109px;
    display: flex;
    justify-content: center;
    .withdraw-clock {
      width: 123px;
      height: 125px;
    }
  }
  .finish-text {
    font-size: 20px;
    font-weight: bold;
    color: ${invite_text};
    line-height: 20px;
    margin-top: 22px;
    text-align: center;
  }
  .finish-desc {
    font-size: 15px;
    font-weight: 400;
    color: #747474;
    line-height: 15px;
    margin-top: 12px;
    text-align: center;
  }
  .finish-btn-wrap {
    padding: 43px 19px 0;
  }
  .finish-btn {
    border: 0px solid #FFFFFF;
    background: linear-gradient(270deg, #FB4C3D 0%, #FDBE37 99%);
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    height: 38px;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_42/withdraw.js